import React from 'react'
import { localized } from '@/decorators/localized'
import LoadingIndicator from '@/components/LoadingIndicator'
import { DatePicker } from '@/components/DatePicker'
import Icon from '@/components/Icon'
import { Row, Col, Button } from 'reactstrap'
import { DropDownList } from '@/components/dropDownList'

@localized()
class AddNewReportSubmitter extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      institution: null,
      validFrom: null,
      validTo: null,

      adding: false
    }
  }
  save () {
    const { institution, validFrom, validTo } = this.state
    if (institution) {
      const dto = {
        id: institution.id,
        validFrom,
        validTo,
        reportGroupId: this.props.reportGroupId
      }
      this.props.addReportSubmitter(dto)
    }
  }
  render () {
    const { localize } = this.props
    const isLoading = (this.props.reportSubmitters.changing === true)
    const canAdd = this.state.institution !== null
    return (
      <div className='AddNewReportSubmitter mt-sm-4'>
        <Row className='new-report-submitter'>
          {isLoading && <Col sm='12'><LoadingIndicator /></Col>}
          {!isLoading && <React.Fragment>
            <div>
              <DropDownList dataSource={this.props.dataSource}
                placeholder={localize(this.props.isGroupSubmitter
                  ? 'Institutions.SelectInstitutionGroup'
                  : 'Institutions.SelectInstitution')}
                value={this.state.institution}
                onChange={({ item }) => this.setState({ institution: item })}
              />
            </div>
            <div>
              <DatePicker
                placeholder={localize('Common.ValidFrom')}
                value={this.state.validFrom}
                onChange={value => this.setState({ validFrom: value })} />
            </div>
            <div>
              <DatePicker
                placeholder={localize('Common.ValidTo')}
                value={this.state.validTo}
                onChange={value => this.setState({ validTo: value })} />
            </div>
            <div>
              <Button disabled={!canAdd} color='success' onClick={() => this.save()}><Icon name='plus' /> {localize('Common.Add')}</Button>
            </div>
          </React.Fragment>}
        </Row>
      </div>
    )
  }
}

export default AddNewReportSubmitter



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingGroups/addNewReportSubmitter.js